module.exports = {
    // basic
    'view-no-matter-who-uploads-it': 'view no matter who uploads it',
    'view-only-if-they-upload-it': 'view only if they upload it',

    // raw
    // template
    'entry-type-access-permissions-help': (words) => `Effective permissions for "${words[0]}"`,
    'entry-type-access-permissions-title': (words) => `Entry Type permissions for "${words[0]}"`,
    'entry-type-access-companies-title': (words) => `Access to "${words[0]}" on "${words[1]}"`,
    'entry-type-access-company-help': (words) => `
    The following companies have access to "${words[0]}" on "${words[1]}".<br />
    Clicking on one of the roles will show you all of its effective permissions.
    `,
    'entry-type-access-title': (words) => `Entry Types on Well "${words[0]}"`,

};
